import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::update
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:219
* @route '/motels/{motel}/channel-manager/switches'
*/
export const update = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/motels/{motel}/channel-manager/switches',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::update
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:219
* @route '/motels/{motel}/channel-manager/switches'
*/
update.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return update.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::update
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:219
* @route '/motels/{motel}/channel-manager/switches'
*/
update.put = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::update
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:219
* @route '/motels/{motel}/channel-manager/switches'
*/
const updateForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::update
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:219
* @route '/motels/{motel}/channel-manager/switches'
*/
updateForm.put = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::createRooms
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:275
* @route '/motels/{motel}/channel-manager/switches/create-rooms'
*/
export const createRooms = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: createRooms.url(args, options),
    method: 'put',
})

createRooms.definition = {
    methods: ["put"],
    url: '/motels/{motel}/channel-manager/switches/create-rooms',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::createRooms
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:275
* @route '/motels/{motel}/channel-manager/switches/create-rooms'
*/
createRooms.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return createRooms.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::createRooms
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:275
* @route '/motels/{motel}/channel-manager/switches/create-rooms'
*/
createRooms.put = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: createRooms.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::createRooms
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:275
* @route '/motels/{motel}/channel-manager/switches/create-rooms'
*/
const createRoomsForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: createRooms.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::createRooms
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:275
* @route '/motels/{motel}/channel-manager/switches/create-rooms'
*/
createRoomsForm.put = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: createRooms.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

createRooms.form = createRoomsForm

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::replayHeld
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:290
* @route '/motels/{motel}/channel-manager/switches/replay-held'
*/
export const replayHeld = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: replayHeld.url(args, options),
    method: 'post',
})

replayHeld.definition = {
    methods: ["post"],
    url: '/motels/{motel}/channel-manager/switches/replay-held',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::replayHeld
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:290
* @route '/motels/{motel}/channel-manager/switches/replay-held'
*/
replayHeld.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return replayHeld.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::replayHeld
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:290
* @route '/motels/{motel}/channel-manager/switches/replay-held'
*/
replayHeld.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: replayHeld.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::replayHeld
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:290
* @route '/motels/{motel}/channel-manager/switches/replay-held'
*/
const replayHeldForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: replayHeld.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\ChannelManagerController::replayHeld
* @see app/Http/Controllers/Admin/Motels/ChannelManagerController.php:290
* @route '/motels/{motel}/channel-manager/switches/replay-held'
*/
replayHeldForm.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: replayHeld.url(args, options),
    method: 'post',
})

replayHeld.form = replayHeldForm

const switches = {
    update: Object.assign(update, update),
    createRooms: Object.assign(createRooms, createRooms),
    replayHeld: Object.assign(replayHeld, replayHeld),
}

export default switches